import { useGetList } from "react-admin";
import type { AggregateBreachClaimantDetail } from "@/types";

export const useBreachClaimantDetails = (policyId: string | undefined, calculationId: string | undefined) => {
  // The /details endpoint is not server-paginated (handler returns all rows
  // without calling getPaginationParams). The data provider still wraps the
  // request through its standard branch — limit/offset query params are
  // ignored by the backend, the {data, pagination} envelope is unwrapped,
  // and we receive { data, total } the same as any other useGetList consumer.
  const { data, isLoading, isError } = useGetList<AggregateBreachClaimantDetail>(
    `policies/${policyId}/aggregate-calculations/${calculationId}/details`,
    {
      pagination: { page: 1, perPage: 1000 },
      sort: { field: "id", order: "ASC" },
    },
    {
      enabled: !!policyId && !!calculationId,
      staleTime: 30_000,
    }
  );

  return { details: data ?? [], isLoading, isError };
};
